import { z } from "zod";

import {
  seoGeoFields,
  systemFields,
  zMedia,
  zReasoning,
  zTransliterations,
} from "@/lib/zod/show-fragments";

/** Read-only view schema for the People show page — full PersonDbDto. */
export const personViewSchema = z
  .object({
    id: z.string(),
    name: z.string().nullish(),
    aliases: z.array(z.string()).nullish(),
    media: zMedia.nullish(),
    knownForDepartment: z.string().nullish(),
    about: z.string().nullish(),
    /** `translations.<locale>.name` — the person's name per language. */
    translations: z
      .record(
        z.string(),
        z.object({ name: z.string().nullish() }).passthrough(),
      )
      .nullish(),
    popularity: z.number().nullish(),
    followers: z.number().nullish(),
    metadata: z
      .object({
        source: z.string().nullish(),
        tmdbId: z.number().nullish(),
        imdbId: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    artistId: z.string().nullish(),
    status: z.string().nullish(),
    enrichmentStatus: z.string().nullish(),
    enrichment: z
      .object({
        reasoning: zReasoning.nullish(),
        ...seoGeoFields,
        transliterations: zTransliterations.nullish(),
        features: z.record(z.string(), z.unknown()).nullish(),
        about: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    hide: z.boolean().nullish(),
    ...systemFields,
  })
  .passthrough();

export type PersonViewType = z.infer<typeof personViewSchema>;
